import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    empty: "You don't have any notifications.",
    errorOccured: 'Internal error may occur. Try again later',
  },
};
